import { withInstall } from '@vuemap/vue-amap-util'
import DistrictLayer from './DistrictLayer.vue'

export const ElAmapLayerDistrict = withInstall(DistrictLayer)
export default ElAmapLayerDistrict
